import { BrowserRouter, Routes, Route } from "react-router-dom";
import { RecoilRoot } from "recoil";
import CreditMain from "./Components/pages/Credit/Main/Main";
import Question from "./Components/pages/Credit/Question/Question";
import Result from "./Components/pages/Credit/Result/Result";

const Router = () => {
  return (
    <BrowserRouter>
      <RecoilRoot>
        <Routes>
          <Route path={`/`} element={<CreditMain />} />
          <Route path={`/credit/question`} element={<Question />} />
          <Route path={`/credit/result`} element={<Result />} />
        </Routes>
      </RecoilRoot>
    </BrowserRouter>
  );
};

export default Router;
